module.exports = __webpack_public_path__ + "static/img/dailyActive.e3224ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/dailyActive.png
// module id = nR83
// module chunks = 55